var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "register-page" },
    [
      _c("newHeaderTop"),
      _vm._v(" "),
      !_vm.verificationModel
        ? _c(
            "div",
            { staticClass: "form" },
            [
              _c("P", { staticClass: "form-title" }, [
                _vm._v(_vm._s(_vm.$t("300031")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "register-tab" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab inline-block",
                    class: {
                      activeTab: _vm.activeName == "email",
                      tabMarL: _vm.isDirection,
                      tabMarR: !_vm.isDirection
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleChange("email")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300033")) + "\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab inline-block",
                    class: {
                      activeTab: _vm.activeName == "phone",
                      tabMarL: _vm.isDirection,
                      tabMarR: !_vm.isDirection
                    },
                    on: {
                      click: function($event) {
                        return _vm.handleChange("phone")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("300034")) + "\n      ")]
                )
              ]),
              _vm._v(" "),
              _c("form", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "email",
                        expression: "activeName == 'email'"
                      }
                    ],
                    staticClass: "form-item"
                  },
                  [
                    _c("p", { staticClass: "form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("300033")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-item-value" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.temp.emailUser,
                            expression: "temp.emailUser"
                          }
                        ],
                        class: _vm.emailError ? "error-border" : "",
                        domProps: { value: _vm.temp.emailUser },
                        on: {
                          blur: _vm.emailBlur,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.temp, "emailUser", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.emailError,
                            expression: "emailError"
                          }
                        ],
                        staticClass: "error-msg"
                      },
                      [_vm._v(_vm._s(_vm.emailErrorMsg))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeName == "phone",
                        expression: "activeName == 'phone'"
                      }
                    ],
                    staticClass: "form-item"
                  },
                  [
                    _c("p", { staticClass: "form-item-label" }, [
                      _vm._v(_vm._s(_vm.$t("300035")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-item-value flex-between" }, [
                      _c("div", { staticClass: "country-code relative" }, [
                        _c(
                          "p",
                          {
                            staticClass: "country flex-between pointer",
                            class: _vm.phoneError ? "error-border" : "",
                            on: {
                              click: function($event) {
                                _vm.vanPopupShow = !_vm.vanPopupShow
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: { src: _vm.countryImg, alt: "" }
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("+" + _vm._s(_vm.temp.areaCode))
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "iconfont",
                              class: _vm.vanPopupShow
                                ? "icon-shangla"
                                : "icon-xiala"
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.temp.phoneUser,
                            expression: "temp.phoneUser"
                          }
                        ],
                        staticClass: "phoneNumber",
                        class: _vm.phoneError ? "error-border" : "",
                        attrs: { maxlength: "11" },
                        domProps: { value: _vm.temp.phoneUser },
                        on: {
                          blur: _vm.phoneBlur,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.temp, "phoneUser", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.phoneError,
                            expression: "phoneError"
                          }
                        ],
                        staticClass: "error-msg"
                      },
                      [_vm._v(_vm._s(_vm.phoneErrorMsg))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-item" }, [
                  _c("p", { staticClass: "form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("300036")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-item-value password-item",
                      class: _vm.isDirection
                        ? "password-item-rtl"
                        : "password-item-ltr"
                    },
                    [
                      _vm.inputType === "checkbox"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.temp.password,
                                expression: "temp.password"
                              }
                            ],
                            class: _vm.passwordError ? "error-border" : "",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.temp.password)
                                ? _vm._i(_vm.temp.password, null) > -1
                                : _vm.temp.password
                            },
                            on: {
                              blur: _vm.passwordBlur,
                              change: function($event) {
                                var $$a = _vm.temp.password,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.temp,
                                        "password",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.temp,
                                        "password",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.temp, "password", $$c)
                                }
                              }
                            }
                          })
                        : _vm.inputType === "radio"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.temp.password,
                                expression: "temp.password"
                              }
                            ],
                            class: _vm.passwordError ? "error-border" : "",
                            attrs: { type: "radio" },
                            domProps: {
                              checked: _vm._q(_vm.temp.password, null)
                            },
                            on: {
                              blur: _vm.passwordBlur,
                              change: function($event) {
                                return _vm.$set(_vm.temp, "password", null)
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.temp.password,
                                expression: "temp.password"
                              }
                            ],
                            class: _vm.passwordError ? "error-border" : "",
                            attrs: { type: _vm.inputType },
                            domProps: { value: _vm.temp.password },
                            on: {
                              blur: _vm.passwordBlur,
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.temp,
                                  "password",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "iconfont eyeIcon absolute pointer",
                        class:
                          _vm.inputType == "password"
                            ? "icon-yincang"
                            : "icon-chakan",
                        on: { click: _vm.changeType }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.passwordError,
                          expression: "passwordError"
                        }
                      ],
                      staticClass: "error-msg"
                    },
                    [_vm._v(_vm._s(_vm.passwordErrorMsg))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-item" }, [
                  _c("p", { staticClass: "form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("300037")) + "\n          "),
                    _c("i", {
                      staticClass: "iconfont",
                      class: _vm.inviteCodeInput
                        ? "icon-shangla"
                        : "icon-xiala",
                      on: {
                        click: function($event) {
                          _vm.inviteCodeInput = !_vm.inviteCodeInput
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-item-value" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.inviteCodeInput || _vm.temp.inviteCode != "",
                          expression: "inviteCodeInput || temp.inviteCode != ''"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.temp.inviteCode,
                          expression: "temp.inviteCode"
                        }
                      ],
                      class: !!this.$route.query.invitationCode
                        ? "disabled-input"
                        : "",
                      attrs: { disabled: !!this.$route.query.invitationCode },
                      domProps: { value: _vm.temp.inviteCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.temp, "inviteCode", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-item-value",
                      staticStyle: { display: "flex", "flex-wrap": "wrap" }
                    },
                    [
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.checked,
                              expression: "!checked"
                            }
                          ],
                          staticClass: "icon pointer checkIcon",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function($event) {
                              _vm.checked = !_vm.checked
                            }
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-weixuanzhong" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.checked,
                              expression: "checked"
                            }
                          ],
                          staticClass: "icon pointer checkIcon",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function($event) {
                              _vm.checked = !_vm.checked
                            }
                          }
                        },
                        [
                          _c("use", {
                            attrs: { "xlink:href": "#icon-xuanzhong" }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "service" }, [
                        _vm._v(_vm._s(_vm.$t("300038"))),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                _vm.language == "zh-TC"
                                  ? "https://superexhelp.zendesk.com/hc/zh-hk/articles/4410464395033"
                                  : _vm.language == "ko"
                                  ? "https://superexhelp.zendesk.com/hc/ko/articles/4411046370457"
                                  : "https://superexhelp.zendesk.com/hc/en-001/articles/4411055405337"
                            }
                          },
                          [_vm._v("《" + _vm._s(_vm.$t("300039")) + "》")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.checked && _vm.submitStatus,
                              expression: "!checked && submitStatus"
                            }
                          ],
                          staticClass: "block error-tip"
                        },
                        [_vm._v(_vm._s(_vm.$t("300040")))]
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "van-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.$t("300041")))]
              ),
              _vm._v(" "),
              _c("p", { staticClass: "loginFun" }, [
                _vm._v(_vm._s(_vm.$t("300327"))),
                _c(
                  "span",
                  { staticClass: "loginBtn", on: { click: _vm.toLogin } },
                  [_vm._v(_vm._s(_vm.$t("300328")))]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.verificationModel
        ? _c("verification", {
            attrs: {
              "user-name":
                _vm.activeName == "phone"
                  ? _vm.temp.phoneUser
                  : _vm.temp.emailUser,
              "area-code": _vm.temp.areaCode,
              isGeet: _vm.isGeet,
              type: _vm.activeName,
              "form-type": "register",
              isCountDown: _vm.isCountDown
            },
            on: {
              submitFun: _vm.submitFun,
              countDownFun: _vm.countDownFun,
              backFun: _vm.backFun
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "country-popup",
          style: { height: "50%" },
          attrs: { round: "", position: "bottom" },
          model: {
            value: _vm.vanPopupShow,
            callback: function($$v) {
              _vm.vanPopupShow = $$v
            },
            expression: "vanPopupShow"
          }
        },
        [
          _c(
            "div",
            { staticClass: "popup-title" },
            [
              _vm._v(_vm._s(_vm.$t("300043")) + "\n      "),
              _c("van-icon", {
                attrs: { name: "cross" },
                on: {
                  click: function($event) {
                    _vm.vanPopupShow = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "country-list" },
            [
              _c(
                "div",
                {
                  staticClass: "search",
                  class: _vm.isDirection ? "search-rtl" : "search-ltr"
                },
                [
                  _c("i", { staticClass: "iconfont icon-sousuo" }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keyWord,
                        expression: "keyWord"
                      }
                    ],
                    attrs: { type: "text", placeholder: _vm.$t("300044") },
                    domProps: { value: _vm.keyWord },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.keyWord = $event.target.value
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.list, function(item) {
                return _c(
                  "div",
                  {
                    staticClass: "list-item",
                    on: {
                      click: function($event) {
                        return _vm.changeCountry(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "flex-center" }, [
                      _c("img", {
                        attrs: { src: item.nationalFlagUrl, alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "country-name" }, [
                        _vm._v(
                          "  " +
                            _vm._s(
                              _vm.language == "zh-CN"
                                ? item.chineseName
                                : item.englishName
                            ) +
                            _vm._s(
                              _vm.language != "zh-CN" && item.name
                                ? "(" + item.name + ")"
                                : ""
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "area-code" }, [
                      _vm._v("+" + _vm._s(item.code))
                    ])
                  ]
                )
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _vm.appDownShow ? _c("appDown", { on: { close: _vm.close } }) : _vm._e(),
      _vm._v(" "),
      _vm.loadingShow
        ? _c("div", { staticClass: "loading-model" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "center",
                  width: "100%",
                  height: "100%"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.staticState + "static/images/loading.gif",
                    alt: ""
                  }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showImgCode
        ? _c("Geet", {
            attrs: {
              isGeet: _vm.isgt,
              "user-name":
                _vm.activeName == "phone"
                  ? _vm.temp.phoneUser
                  : _vm.temp.emailUser,
              product: "bind"
            },
            on: { geetPath: _vm.GeetPath, clickChange: _vm.GeetChange }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0060bd44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0060bd44","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/register.vue
// module id = 4Auh
// module chunks = 0